module.exports = __webpack_public_path__ + "img/ic_login_logo.53acacd4.png";